// Le passkey dell'account (tela, artboard 48): aggiungerne una da questo dispositivo, toglierle.
import { useCallback, useEffect, useState } from 'react';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { Icon } from '../../components/Icon';
import { ApiError, api, type Passkey } from '../../lib/api';
import { deviceName, passkeysSupported, registerPasskey } from '../../lib/passkeys';
import { useStore } from '../../store/StoreProvider';

const day = (at: number | null) =>
  at ? new Date(at * 1000).toLocaleDateString('it-IT', { dateStyle: 'medium' }) : '';

export function PasskeysCard() {
  const { toast } = useStore();
  const [keys, setKeys] = useState<Passkey[]>([]);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    api.passkeys().then(setKeys, () => setKeys([]));
  }, []);
  useEffect(load, [load]);

  const add = async () => {
    setBusy(true);
    try {
      await registerPasskey(deviceName());
      toast({ kind: 'success', title: 'Passkey aggiunta' });
      load();
    } catch (e) {
      // l'utente che chiude la finestra del sistema non è un errore da mostrare
      if (e instanceof DOMException && e.name === 'NotAllowedError') return;
      toast({
        kind: 'danger',
        title: 'Passkey non aggiunta',
        body: e instanceof ApiError && e.detail ? e.detail : (e as Error).message,
      });
    } finally {
      setBusy(false);
    }
  };

  const remove = (k: Passkey) =>
    void api
      .removePasskey(k.id)
      .then(() => {
        toast({ kind: 'success', title: 'Passkey tolta' });
        load();
      })
      .catch(() => toast({ kind: 'danger', title: 'Passkey non tolta' }));

  return (
    <Card>
      <div className="settings-block">
        <div className="settings-block-text">
          <span className="t-overline faint">Sicurezza</span>
          <span className="t-strong">Passkey · {keys.length}</span>
          <span className="t-caption dim">
            Entri con Touch ID, Face ID o la chiave del telefono, senza password.
          </span>
        </div>
        <Button
          size="sm"
          variant="primary"
          icon="plus"
          loading={busy}
          disabled={!passkeysSupported()}
          onClick={() => void add()}
        >
          Aggiungi passkey
        </Button>
      </div>
      {!passkeysSupported() && (
        <div className="t-caption faint" style={{ marginTop: 8 }}>
          Questo browser non gestisce le passkey.
        </div>
      )}
      {keys.map((k) => (
        <div key={k.id} className="passkey-row">
          <Icon name="fingerprint" size={18} />
          <div style={{ flex: 1, minWidth: 0, display: 'grid' }}>
            <span className="t-strong">{k.name}</span>
            <span className="t-caption faint">
              aggiunta il {day(k.createdAt)} ·{' '}
              {k.usedAt ? `usata il ${day(k.usedAt)}` : 'mai usata'}
            </span>
          </div>
          <Button size="sm" variant="danger" onClick={() => remove(k)}>
            Togli
          </Button>
        </div>
      ))}
    </Card>
  );
}
